import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-new',
  templateUrl: './contact-new.component.html',
  styleUrls: ['./contact-new.component.scss'],
})
export class ContactNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
